<template>
    <layout-theme>
        <div class="container mt-5">
            <div class="column is-12 is-centered survey-box">
                <h1>Pesquisa</h1>

                <div v-if="survey">
                    <h2>{{ survey.name }}</h2>

                    <b-field v-for="question in survey.questions" :key="question.id" :label="question.text" class="block">
                        <div v-for="alternative in question.alternatives" :key="alternative.id" >
                            <b-input v-if="question.type == 'DISCURSIVE'" 
                                value=""
                                :name="`questions[${question.id}][answer][discursive_answer][${alternative.id}]`"
                                v-model="answers[question.id]['answer']['discursive_answer'][alternative.id]"
                            />

                            <div v-if="question.type == 'MULTIPLE-ONE'">
                                <b-radio
                                    :name="`questions[${question.id}][answer][alternative_id][]`"
                                    :native-value="alternative.id"
                                    v-model="answers[question.id]['answer']['alternative_id']"
                                    @input="answers = Object.assign({}, answers)"
                                >
                                    {{ alternative.text }}
                                </b-radio>
                                <b-input v-if="alternative.justifiable"
                                    v-show="answers[question.id]['answer']['alternative_id'] == alternative.id"
                                    placeholder="Justique"
                                    value=""
                                    :name="`questions[${question.id}][answer][discursive_answer][${alternative.id}]`"
                                    v-model="answers[question.id]['answer']['discursive_answer'][alternative.id]"
                                />
                            </div>
                        </div>
                    </b-field>

                    <b-field class="pt-5">
                        <b-button
                            :disabled="sending"
                            icon-left="save"
                            label="Enviar"
                            type="is-success"
                            @click="send"
                        />
                    </b-field>
                </div>
            </div>
        </div>
    </layout-theme>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import LayoutTheme from '@/components/LayoutTheme'

const NEXT = '/satisfaction-survey'

export default {
    components: {
        LayoutTheme,
    },

    data() {
        return {
            survey: null,
            answers: {},
            sending: false,
        }
    },

    watch: {
        survey: function() {
            this.setupAnswers()
        }
    },

    beforeMount() {
        this.setupAnswers()
    },

    mounted() {
        api.userRequest({
            url: `user/me/survey-to-answer`,
            method: 'get',
            params: {
                location_id: '1', // 1=Atualização cadastral (interno)
                unit_id: this.unit.id,
            }
        }).then(data => {
            if (data && data.survey && data.survey.id) {
                this.survey = data.survey
            } else {
                console.log('Nenhuma pesquisa encontrada para ser respondida')
                this.$router.push(NEXT)
            }
        }).catch(e => {
            console.log('Erro ao obter pesquisas', e.message)
            this.$router.push(NEXT)
        })
    },

    methods: {
        setupAnswers() {
            if (this.survey && this.survey.questions) {
                this.survey.questions.forEach(question => {
                    question.alternatives.forEach(alternative => {
                        if (question.type == 'DISCURSIVE') {
                            _.setWith(this.answers, `[${question.id}]['answer']['discursive_answer']["${alternative.id}"]`, '', Object)
                            
                        } else {
                            _.setWith(this.answers, `[${question.id}]['answer']['alternative_id']`, '', Object)
                        }

                        if (alternative.justifiable) {
                            _.setWith(this.answers, `[${question.id}]['answer']['discursive_answer']['${alternative.id}']`, '', Object)
                        }
                    })
                })
            }
        },

        validate() {
            let validationFail = false
            Object.keys(this.answers).every(questionId => {
                let question = this.answers[questionId]
                if ('alternative_id' in question.answer && !question.answer.alternative_id) {
                    validationFail = true
                    this.$buefy.toast.open({
                        duration: 4000,
                        message: 'Existem perguntas sem nenhuma opção selecionada! Por favor, responda a todas as perguntas.',
                        type: 'is-danger'
                    })
                    return false
                }

                if (!('alternative_id' in question.answer) && 'discursive_answer' in question.answer) {
                    let discursives = 0
                    _.forEach(question.answer.discursive_answer, alternative => {
                        if (!alternative) {
                            discursives++
                        }
                    })
                    if (discursives > 0) {
                        validationFail = true
                        this.$buefy.toast.open({
                            duration: 4000,
                            message: 'Existem perguntas em branco! Por favor, responda a todas as perguntas.',
                            type: 'is-danger'
                        })
                        return false
                    }
                }

                if ('alternative_id' in question.answer 
                    && 'discursive_answer' in question.answer
                    && question.answer.alternative_id in question.answer.discursive_answer
                ) {
                    if (!question.answer.discursive_answer[question.answer.alternative_id]) {
                        validationFail = true
                        this.$buefy.toast.open({
                            duration: 4000,
                            message: 'Existem justificativas em branco! Por favor, preencha todas as justificativas.',
                            type: 'is-danger'
                        })
                        return false
                    }
                }

                return true
            })

            return !validationFail
        },

        send() {
            if (this.validate()) {
                const loading = this.$buefy.loading.open()
                this.sending = true

                api.appRequest({
                    url: `survey/${this.survey.id}/interview`,
                    method: 'post',
                    data: {
                        questions: this.answers,
                        unit_id: this.unit.id,
                        location_id: 1, // 1=Atualização cadastral (interno)
                        login: this.user.username,
                    },
                }).then(() => {
                    this.$router.push(NEXT)
                }).catch(e => {
                    let message = 'Erro ao salvar respostas da pesquisa'

                    if (e.message) {
                        message = e.message
                    }

                    if (e.response && e.response.data && e.response.data.exception) {
                        const exception = e.response.data.exception

                        if (exception.message) {
                            message = `<p>${exception.message}</p>`
                        }

                        switch (exception.type) {
                            case 'ValidationException':
                                if (exception.details) {
                                    message += Object.values(exception.details)[0][0]
                                    this.errors = exception.details
                                } else {
                                    message += exception.message ? exception.message : exception.type
                                }
                                break

                            default:
                                message += exception.message ? exception.message : exception.type
                                break;
                        }
                    }

                    this.$buefy.toast.open({
                        duration: 5000,
                        message: message,
                        position: 'is-bottom',
                        type: 'is-danger'
                    })
                }).finally(() => {
                    this.sending = false
                    loading.close()
                })
            } else {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: 'Responda a todas as questões.',
                    position: 'is-bottom',
                    type: 'is-danger'
                })
            }
        },
    },

    computed: {
        ...mapGetters({
            user: 'getUser',
            equipment: 'getEquipment',
            unit: 'getUnit',
        })
    }
}
</script>